export enum AuthErrors {
  UNAUTHORIZED = 401,
  FORBIDDEN = 403
}
